import { render, staticRenderFns } from "./CorreView.vue?vue&type=template&id=7a761996&"
import script from "./CorreView.vue?vue&type=script&lang=js&"
export * from "./CorreView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports